const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/tpsp/v1frontend/tp-tariff/search', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
